// Generated types for FunctionalBreakdownTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { NeoNodeReadAPI } from '../../shared/types/neonode';
import { TaskReadAPI, TaskWriteAPI } from '../../tasks/types/task';
import { NeoNodeReadAPISchema } from '../../shared/types/neonode';
import { TaskReadAPISchemaObject, TaskWriteAPISchemaObject } from '../../tasks/types/task';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface FunctionalBreakdownTaskReadAPI extends TaskReadAPI {
}

export interface FunctionalBreakdownTaskWriteAPI extends TaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const FunctionalBreakdownTaskReadAPISchema: z.ZodType<FunctionalBreakdownTaskReadAPI> = TaskReadAPISchemaObject.extend({}).passthrough();

export const FunctionalBreakdownTaskWriteAPISchema: z.ZodType<FunctionalBreakdownTaskWriteAPI> = TaskWriteAPISchemaObject.extend({}).passthrough();
